import { Alert } from '@mui/material';
import { motion } from 'framer-motion';
import { memo } from 'react';
import { MotionContainer, varBounceInDown } from './animate';

// Agora o componente aceita o tipo e o ícone do alerta como props.
function ChatReconectandoAlert({ mensagem, timer, severity, icon }) {
  const timerText = timer !== null && timer >= 0 ? ` (${timer}s)` : '';

  return (
    <MotionContainer initial="initial" open>
      <motion.div variants={varBounceInDown}>
        <Alert
          variant="filled"
          severity={severity}
          icon={icon}
          sx={{
            borderRadius: '0px 0px 10px 10px',
            p: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {mensagem}
          {timerText}
        </Alert>
      </motion.div>
    </MotionContainer>
  );
}

export default memo(ChatReconectandoAlert);
